export default __webpack_public_path__ + "assets/models/6db9c7ad5dcb994c0f02141601541f0c.glb";